
import { Entity } from '../base/entity';

export class UserCalendar extends Entity {

    public static readonly TABLENAME = 'user_calendar';


    public static readonly ID = "id";
    public static readonly APP_USER_ID = "app_user_id";
    public static readonly DATE_OF_EVENT = "date_of_event";
    public static readonly DESCRIPTION = "description";
    public static readonly ACTIVITY = "activity";

    id: number;
    appUserId: string;
    dateOfEvent: Date;
    description: string;
    activity: number;
}
